import axios from "axios";
import * as GlobalService from './../global_services';

const BARCODE_ELEMENTS = [
    { Name: 'MU Label', IsSavedElement: false, ElementType: 3},
    { Name: 'Quantity', IsSavedElement: false, ElementType: 4}
];

const isBlankValue = function (value) {
    return typeof value == 'undefined' || value === null || value === '';
};

const isDefaultBarcodeElement = function (elementName) {
    var lookupKey = (elementName || '').toLowerCase();

    return BARCODE_ELEMENTS.some(function (element) {
        return element.Name.toLowerCase() === lookupKey;
    });
};

const getBarcodeElementName = function (element) {
    if (typeof element === 'string') {
        return element;
    }

    if (element) {
        return element.Name || element.DisplayName || element.ElementName || element.Value || element.value || '';
    }

    return '';
};

const normalizeBarcodeElement = function (element) {
    if (typeof element === 'string') {
        return {
            Name: element,
            IsSavedElement: false
        };
    }

    var name = getBarcodeElementName(element);
    return Object.assign({}, element, {
        Name: name,
        IsSavedElement: element && typeof element.IsSavedElement != 'undefined' ? element.IsSavedElement : false,
        ElementType: element.ElementType
    });
};

const normalizeBarcodeElements = function (elements, includeDefaultElements) {

    var normalizedElements = [];
    var elementLookup = {};

    (elements || []).forEach(function (element) {
        var normalizedElement = normalizeBarcodeElement(element);
        var elementName = getBarcodeElementName(normalizedElement);
        var lookupKey = elementName.toLowerCase();

        if (elementName && !elementLookup[lookupKey] && (!isDefaultBarcodeElement(elementName) || !isBlankValue(normalizedElement.Start) || !isBlankValue(normalizedElement.Length))) {
            normalizedElements.push(normalizedElement);
            elementLookup[lookupKey] = true;
        }
    });

    if (!includeDefaultElements) {
        return normalizedElements;
    }

    BARCODE_ELEMENTS.forEach(function (element) {
        var lookupKey = element.Name.toLowerCase();

        if (!elementLookup[lookupKey]) {
            normalizedElements.push(element);
            elementLookup[lookupKey] = true;
        }
    });

    return normalizedElements;
};

const normalizeBarcodeDefs = function (barcodeDefs) {
    return (barcodeDefs || []).map(function (barcodeDef) {
        return Object.assign({}, barcodeDef, {
            BarcodeElements: normalizeBarcodeElements(barcodeDef.BarcodeElements, false)
        });
    });
};

export const getBarcodeInitial = function () {
    return axios.all([
        GlobalService.GetCustomersAndFacility()
    ]).then(axios.spread(function () {
        var optionResponse = {
            customerList: GlobalService.getCustomerList(false)
        };
        return optionResponse;
    }));
}

export const getFindBarcodeDefsPageLoad = function (customerId) {
    var custUri = '/customers/' + customerId;

    return axios.post('/WebUI/Customers/BarcodeDefs/FindBarcodeDefsPageLoad', { customerUri: custUri }).then(function (response) {
        var returnObj = [];
        if (typeof response != "undefined" && (response.status == 204 || response.status == 200)) {
            returnObj = response.data || {};
            returnObj.BarcodeDefs = normalizeBarcodeDefs(returnObj.BarcodeDefs);
        }
        return returnObj;
    });
}

export const DeleteBarcodeDefs = function (uriArray) {
    return axios.post('/WebUI/Customers/BarcodeDefs/DeleteBarcodeDefs', { barcodeDefUrIs: uriArray }).then(function (response) {
        return response.data;
    });
}
export const createBarcodeDefsPageLoad = function (customerId) {
    var custUri = '/customers/' + customerId;

    return axios.post('/WebUI/Customers/BarcodeDefs/CreateBarcodeDefsPageLoad', { customerUri: custUri }).then(function (response) {
        var returnObj = [];
        if (typeof response != "undefined" && (response.status == 204 || response.status == 200)) {
            returnObj = response.data;
            returnObj.Elements = normalizeBarcodeElements(returnObj.Elements, true);
        }
        return returnObj;
    });
}

export const saveBarcodeDef = function (custUri, def) {

    return axios.post('/WebUI/Customers/BarcodeDefs/SaveBarcodeDef', { custUri: custUri, def: def }).then(function (response) {
        var returnObj = [];
        if (typeof response != "undefined" && (response.status == 204 || response.status == 200)) {
            returnObj = response.data;
        }
        return returnObj;
    });
}